import React from 'react';
import Skeleton from '../Skeleton/Skeleton';
import './DailyTableSkeleton.scss';

const DailyTableSkeleton = () => {
  return (
    <div className="daily-table-skeleton">
      <h2 className="daily-table-skeleton__title">
        <Skeleton width="200px" height="24px" variant="text" />
      </h2>
      
      <div className="daily-table-skeleton__wrapper">
        <table className="daily-table-skeleton__table">
          <thead>
            <tr>
              <th>Game</th>
              <th>Current Streak</th>
              <th>Best Streak</th>
              <th>Today's Challenge</th>
            </tr>
          </thead>
          <tbody>
            {/* Render 3 skeleton rows */}
            {[...Array(3)].map((_, index) => (
              <tr key={index} className="daily-table-skeleton__row">
                <td className="daily-table-skeleton__cell daily-table-skeleton__cell--game-name">
                  <Skeleton width="120px" height="16px" variant="text" />
                </td>
                <td className="daily-table-skeleton__cell daily-table-skeleton__cell--streak">
                  <div className="daily-table-skeleton__streak-cell">
                    <Skeleton width="16px" height="16px" variant="circular" />
                    <Skeleton width="20px" height="16px" variant="text" style={{ marginLeft: '8px' }} />
                  </div>
                </td>
                <td className="daily-table-skeleton__cell daily-table-skeleton__cell--streak">
                  <div className="daily-table-skeleton__streak-cell">
                    <Skeleton width="16px" height="16px" variant="circular" />
                    <Skeleton width="20px" height="16px" variant="text" style={{ marginLeft: '8px' }} />
                  </div>
                </td>
                <td className="daily-table-skeleton__cell daily-table-skeleton__cell--status">
                  <Skeleton 
                    width="100px" 
                    height="32px" 
                    variant="button"
                    borderRadius="16px"
                  />
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DailyTableSkeleton;